import { type ReactElement } from 'react'
import { cn } from '@/lib/utils'

type Variant = 'editing' | 'running' | 'succeeded' | 'failed' | 'checked'

interface Props {
  variant: Variant
  label: string
}

const variantClass: Record<Variant, string> = {
  editing: 'bg-(--bp-surface2) text-(--bp-ink3)',
  running: 'bg-(--bp-accent-pale) text-(--bp-accent)',
  succeeded: 'bg-(--bp-ok-pale) text-(--bp-ok)',
  failed: 'bg-(--bp-critical-pale) text-(--bp-critical)',
  checked: 'bg-(--bp-ok-pale) text-(--bp-ok)'
}

export function StatusBadge ({ variant, label }: Props): ReactElement {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-semibold',
        variantClass[variant]
      )}
    >
      {label}
    </span>
  )
}
